let connectName = "altsa-hcs-aal-prod";
  let loginUrl = "https://launcher.myapps.microsoft.com/api/signin/305a5bd4-03a7-4c7c-96bd-ac4290ca44bd?tenantId=11d0e217-264e-400a-8ba0-57dcc127d72d&RelayState=https%3a%2f%2fus-west-2.console.aws.amazon.com/connect/federate/b5f7cc15-5078-475a-9d61-6d233d433011?destination=%2Fconnect%2Fccp-v2";
  let region = "us-west-2";

  // set default values
  export const CONNECT_NAME = connectName.includes("<") ? "company-name-connect-dev" : connectName;
  export const CONNECT_URL = "https://" +CONNECT_NAME + ".my.connect.aws/connect/";
  export const CCP_URL = "https://" + CONNECT_NAME + ".my.connect.aws/connect/ccp-v2";
  export const LOGIN_URL = loginUrl.includes("<") ? "NA" : loginUrl;
  export const REGION = region.includes("<") ? "NA" : region;